import { render, staticRenderFns } from "./saleSettingsPage.vue?vue&type=template&id=684c7f4b&"
import script from "./saleSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./saleSettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports